import { useMemo, useState } from "react";
import { generatePath, Link, useNavigate, useParams } from "react-router-dom";
import { HOME_EDUCATION_LIST, PRIVATE_CLIENT_LIST, SCHOOL_CLIENT_ADD, SCHOOL_CLIENT_DETAIL, SCHOOL_CLIENT_LIST } from "config/paths";
import { Col, Container, Dropdown, Row } from "react-bootstrap";
import { Breadcrumbs, NoRecordFoundV2 } from "components/Common/Common";
import { useGetSchoolClientDataQuery } from "store/services/clients/school.client";
import { store } from "store/store";
import { dateFormat, getClientBreadCrumbs, userFullName } from "helpers/common";
import { useClientsServiceStatusListQuery } from "store/services/utility";
import { useUpdateTherapistServiceStatusMutation } from "store/services/clientCaseLoads";
import LoadingIndicator from "components/shared/LoadingIndicator";
import LoadingOverlay from "components/shared/LoadingOverlay";
import { useGetHomeEducationClientDetailsQuery } from "store/services/clients/homeEducation.client";
import { usePrivateClientDetailsQuery } from "store/services/clients/private.client";
import { useLazyUpdateClientStatusQuery } from "store/services/client";
import confirmDialogV2 from "utils/confirmationDialogV2";
import { useChatterClientDetailsQuery } from "store/services/clients/chatter.client";


const ServiceStatusPage = () => {
    const state = store.getState();
    const user = state.auth.user;
    const navigate = useNavigate()
    const { clientId, moduleName, clientType } = useParams()

    console.log('clientId, clientType', clientId, clientType)


    const { data: clientDetails, isLoading, isFetching, refetch } = clientType == "school" ? useGetSchoolClientDataQuery(clientId) : clientType == "private" ? usePrivateClientDetailsQuery(clientId) : clientType == "chatter" ? useChatterClientDetailsQuery(clientId) : useGetHomeEducationClientDetailsQuery(clientId);
    const { data: serviceStatusList, isLoading: serviceStatusListLoading } = useClientsServiceStatusListQuery({ module: "client_service", client_type: clientType });
    const serviceStatusOptions = serviceStatusList?.map(i => ({ value: i.id, label: i.title }))?.filter((x) => x?.value != 181);;
    const [updateTherpaistServiceStatus, { isLoading: updateTherpaistServiceStatusLoading }] = useUpdateTherapistServiceStatusMutation()
    const [updateStatus, { isLoading: updateStatusLoading }] = useLazyUpdateClientStatusQuery()

    // const clientBreadCrumb = clientType == "school" ? { label: "School Clients", path: SCHOOL_CLIENT_LIST } :
    //     clientType == "private" ? { label: "Private Clients", path: PRIVATE_CLIENT_LIST } :
    //         { label: "Home Education Clients", path: HOME_EDUCATION_LIST };

    // const breadcrumbItems = [
    //     clientBreadCrumb,
    //     { label: userFullName(clientDetails) || "Client Details", path: generatePath(SCHOOL_CLIENT_DETAIL, { id: clientId }) },
    //     { label: "Service Status" },
    // ];

    const breadcrumbItems = useMemo(() => getClientBreadCrumbs(clientId, clientType, clientDetails, "Service Status"), [clientType, clientDetails, clientId]);

    // const breadcrumbItems = []


    const handleServiceStatus = async (id, therapistId) => {
        const payload = {
            service_status: id
        }
        try {
            await updateTherpaistServiceStatus({ payload, id: therapistId }).unwrap()
            refetch()
        } catch (error) {
            console.log("Error updating service status: ", error)
        }
    }

    const handleDischarge = async (e) => {
        e.stopPropagation();
        const isConfirm = await confirmDialogV2({
            title: "Are you sure you want to discharge this client?",
            message: "Users will no longer be able to create reports or add to the client file.",
        });
        if (!isConfirm) {
            return;
        }
        try {
            await updateStatus({ clientId, clientType, status: "discharged" }).unwrap();
            refetch()
            navigate(generatePath(SCHOOL_CLIENT_DETAIL, { id: clientId }))
        } catch (error) {
            console.log('error', error)
        }
    }

    const therapists =
        clientDetails?.clientCaseloads
            // Only the regular caseload belongs on the client detail page; MDT caseloads are managed on the MDT screens
            ?.filter(c => c?.case_type === "regular")
            ?.flatMap(c => c.clientCaseloadTherapist) || [];


    return (
        <>
            {
                isLoading ? <LoadingIndicator /> :
                    <section
                        className={`position-relative ClientDetail`}
                    >
                        {(isFetching || updateStatusLoading || updateTherpaistServiceStatusLoading) && <LoadingOverlay />}
                        <Container fluid>
                            <Row style={{ paddingLeft: '12px' }} className="pt-3">
                                <Col lg="6">
                                    <Breadcrumbs items={breadcrumbItems} themeBlueV2 />
                                </Col>
                            </Row>
                            <div className="mt-4" style={{ paddingLeft: '12px', borderRadius: "4px" }}>

                                <Row className="justify-content-between" >
                                    <Col lg='9'>
                                        <p className="twenty proxima-regular mb-0" style={{ color: "#000" }}>
                                            SERVICE STATUS
                                        </p>
                                    </Col>
                                    <Col lg="3">
                                        <ul className="list-unstyled ps-0 mb-0 d-flex align-items-center justify-content-center flex-wrap gap-10">
                                            <li className="">
                                                <Link onClick={(e) => clientDetails?.status != "discharged" && handleDischarge(e)} style={{ opacity: clientDetails?.status == "discharged" && "0.5" }} className="blue-discharge-screen-btn mt-0 d-flex align-items-center justify-content-center">
                                                    Discharge Client
                                                </Link>
                                            </li>
                                        </ul>
                                    </Col>
                                </Row>
                            </div>
                            <div className="mt-2">
                                <table className="w-100">
                                    <thead>
                                        <tr>
                                            <th className="fw-medium " style={{ padding: "15px 10px", borderBottom: "2px solid #315D99" }}>
                                                DATE
                                            </th>
                                            <th className="fw-medium " style={{ padding: "15px 10px", borderBottom: "2px solid #315D99" }}>
                                                DISCIPLINE
                                            </th>
                                            <th className="fw-medium " style={{ padding: "15px 10px", borderBottom: "2px solid #315D99" }}>
                                                CLINICAN
                                            </th>
                                            <th className="fw-medium " style={{ padding: "15px 10px", borderBottom: "2px solid #315D99" }}>
                                                STATUS
                                            </th>
                                        </tr>
                                    </thead>
                                    {
                                        therapists?.length > 0 ?
                                            <tbody>
                                                {
                                                    therapists
                                                        .sort((a, b) => new Date(b.updatedAt) - new Date(a.updatedAt))
                                                        .map((item) =>
                                                            item.clientCaseloadMapping.map((caseloadMapping) => {

                                                                return (
                                                                    <tr>
                                                                        <td style={{ padding: "15px 10px", borderRadius: "0", borderBottom: "1px solid #8F8F8F" }}>{dateFormat(item?.updatedAt, "MMM D, YYYY")}</td>
                                                                        <td className="" style={{ padding: "15px 10px", borderRadius: "0", borderBottom: "1px solid #8F8F8F" }}>
                                                                            <div>
                                                                                <span className={`discipline-${item?.caseDiscipline?.assign_term}-capsule-bcg`} style={{ padding: "7px 10px", marginRight: "3px", borderRadius: "8px" }}>{item?.caseDiscipline?.assign_term}</span>
                                                                            </div>
                                                                        </td>
                                                                        <td style={{ padding: "15px 10px", borderRadius: "0", borderBottom: "1px solid #8F8F8F" }}>
                                                                            {userFullName(caseloadMapping?.caseTherapist)}</td>
                                                                        <td style={{ padding: "15px 10px", borderRadius: "0", borderBottom: "1px solid #8F8F8F" }}>

                                                                            <Dropdown onSelect={(e) => handleServiceStatus(e, item?.id)}>
                                                                                <Dropdown.Toggle
                                                                                    disabled={["active", "incoming"].includes(clientDetails?.status) ? false : true}
                                                                                    variant="light"
                                                                                    id="custom-dropdown"
                                                                                    style={{
                                                                                        border: "1px solid #2a5ca3",
                                                                                        backgroundColor: "#f6f9ff",
                                                                                        color: "#2a5ca3",
                                                                                        width: "200px",
                                                                                        textAlign: "left",
                                                                                    }}
                                                                                >
                                                                                    {item?.caseServiceStatus?.title || "Select"}
                                                                                </Dropdown.Toggle>

                                                                                <Dropdown.Menu
                                                                                    style={{
                                                                                        width: "200px",
                                                                                        padding: 0,
                                                                                        borderRadius: "4px",
                                                                                    }}
                                                                                >
                                                                                    {serviceStatusOptions?.map((item, index) => (
                                                                                        <Dropdown.Item
                                                                                            key={index}
                                                                                            // onClick={() => onSelect(item)}
                                                                                            // active={selected === item}
                                                                                            eventKey={item?.value}
                                                                                            style={{
                                                                                                padding: "10px",
                                                                                                fontSize: "14px",
                                                                                                color: "#2a5ca3",
                                                                                            }}
                                                                                        >
                                                                                            {item?.label}
                                                                                        </Dropdown.Item>
                                                                                    ))}
                                                                                </Dropdown.Menu>
                                                                            </Dropdown>


                                                                        </td>
                                                                    </tr>
                                                                )
                                                            }
                                                            )
                                                        )
                                                }
                                            </tbody> : <tr><td colSpan={4}><NoRecordFoundV2 /></td></tr>
                                    }
                                </table>
                            </div>
                        </Container>
                    </section>
            }
        </>
    );

};

export default ServiceStatusPage;